import { History } from 'history';

export const useLandingPage = (): {
  persistLandingPage: () => void;
  restoreLandingPage: (history: History) => void;
} => {
  const persistLandingPage = () => {
    localStorage.setItem(
      'landingPage',
      `${window.location.pathname}${window.location.search}${window.location.hash}`
    );
  };

  const restoreLandingPage = (history: History) => {
    const landingPage = localStorage.getItem('landingPage');
    localStorage.removeItem('landingPage');

    if (landingPage) {
      history.push(landingPage);
    }
  };

  return {
    persistLandingPage,
    restoreLandingPage
  };
};
